import { trackEvent } from '@/utils/gtags';

const SECTION_ID = 'home_proof_stats';

/**
 * ### HomeProofCtaId
 *
 * Identifies which proof-section CTA was clicked. The two CTAs stay
 * distinguishable in analytics, so the overview click and the consultation
 * click are never read as one number.
 */
export type HomeProofCtaId = 'industrial_overview' | 'process_consult';

/**
 * ### trackHomeProofCtaSelection
 *
 * Records a proof-section CTA click as a content selection, not as a
 * conversion: the lead itself is reported by the inquiry form once it is
 * submitted. Silently does nothing when the analytics tag is absent, which is
 * the case in development and before consent.
 *
 * @param ctaId The CTA that was clicked
 */
export function trackHomeProofCtaSelection(ctaId: HomeProofCtaId) {
  trackEvent('select_content', {
    content_type: 'home_cta',
    item_id: ctaId,
    section_id: SECTION_ID,
  });
}
